export const environment = {
	production: true,
	apiUrl: 'https://ticketing-customer-live.azurewebsites.net',
	coreUrl: 'https://tickets-api.stadium-360.net',
	DataIntegrityKey: 'E7aVEc5y9s34LaUQ',
	auth0: {
		omonoia: {
			enabled: true,
			domain: 'dev-nb3siwo3ef6pc33d.eu.auth0.com',
			clientId: 'vx3SSUvp1qfVO90RUZogTjpgvZHOAI6m',
			// NOTE: the trailing space is REQUIRED — the Auth0 API Identifier was
			// created with a trailing space, so the audience must match it exactly.
			// Do not let an editor/formatter trim it or Auth0 returns "Service not found".
			audience: 'https://api-dev.ticketing.techlink.com.cy '
		}
		// Add other portals as they are onboarded, e.g.:
		// olympiakos: { enabled: true, domain: '...', clientId: '...', audience: '...' }
	}
};
